import { useLocation } from "react-use";
import React from "react";
import Styles from "styles";
import Footer from "shared/component/footer/footer";
import { ToastContainer } from "react-toastify";
import AppRoutes from "routes";

function App() {
  const { pathname } = useLocation();

  React.useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return (
    <div className="App">
      <Styles />
      <ToastContainer />
      <AppRoutes />
      <Footer />
    </div>
  );
}

export default App;
